<template>
  <div class="inline-selector" :class="{'no-grid': !isScrollable}">
    <font-awesome-icon :icon="['fas','chevron-left']" class="selector-arrow selector-arrow__left"
                       @click="previous"
                       :class="{
                         'no-display': !isScrollable,
                         arrow: !isFirstItemOnScreen,
                         'no-selectable': isFirstItemOnScreen
                       }"/>
    <div class="inline-selector__list" ref="listItem">
      <div v-for="(item,index) in items" @click="()=>{onItemSelected(index)}"
           :key="getItemLabel(item) +index" class="inline-selector__list__item">
        <slot v-bind:item="item"
              v-bind:isSelected="selectedItem === index">
          <div :key="getItemLabel(item) +index" class="inline-selector__list__item--default"
               :class="{'inline-selector__list__item--active': selectedItem === index}">
            {{getItemLabel(item)}}
          </div>
        </slot>
      </div>
    </div>
    <font-awesome-icon :icon="['fas', 'chevron-right']" class="selector-arrow selector-arrow__right"
                       @click="next"
                       :class="{
                         'no-display': !isScrollable,
                         arrow: !isLastItemOnScreen,
                         'no-selectable': isLastItemOnScreen
                       }"/>
  </div>
</template>

<script>

export default {
  name: 'InlineSelector',
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
      validator(value) {
        if (value.length === 0) return true;
        for (const item of value) {
          if (item.name === undefined && item.label === undefined) return false;
        }
        return true;
      },
    },
    selectedCategory: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      itemSelector: null,
      hasChildren: false,
      isFirstItemOnScreen: true,
      isLastItemOnScreen: false,
      selectedItem: null,
    };
  },
  computed: {
    isScrollable() {
      if (this.hasChildren) {
        const { children } = this.itemSelector;
        if (!children) return false;
        const lastChild = children[children.length - 1];
        return (this.itemSelector.getBoundingClientRect().right
          <= lastChild.getBoundingClientRect().right);
      }
      return true;
    },
  },
  methods: {
    getItemLabel(item) {
      return item.label || item.name;
    },
    onItemSelected(index) {
      this.$emit('update:item', index);
      this.selectedItem = index;
      const { children } = this.itemSelector;
      if (!children) return;
      const child = children[index];
      child.scrollIntoView();
    },
    next() {
      if (this.isLastItemOnScreen) return;
      this.scroll(150);
    },
    previous() {
      if (this.isFirstItemOnScreen) return;
      this.scroll(-150);
    },
    scroll(amount) {
      this.itemSelector.scrollBy(amount, 0);
    },
    detectScrollingPosition() {
      this.isFirstItemOnScreen = this.itemSelector.scrollLeft === 0;
      this.isLastItemOnScreen = this.itemSelector.scrollLeft
        >= this.itemSelector.scrollWidth - this.itemSelector.clientWidth;
    },
    handleWheel({ deltaY }) {
      this.scroll(deltaY * 25);
    },
    handleScroll() {
      this.detectScrollingPosition();
    },
    init() {
      this.itemSelector = this.$refs.listItem;
      this.itemSelector.addEventListener('wheel', this.handleWheel);
      this.itemSelector.addEventListener('scroll', this.handleScroll);
    },
  },
  mounted() {
    this.$nextTick(this.init);
  },
  updated() {
    this.detectScrollingPosition();
  },
  beforeDestroy() {
    if (this.itemSelector) {
      this.itemSelector.removeEventListener('wheel', this.handleWheel);
      this.itemSelector.removeEventListener('scroll', this.handleScroll);
    }
  },
  watch: {
    'itemSelector.children': {
      handler(v) {
        this.hasChildren = v.length > 0;
      },
      deep: true,
    },
    selectedCategory(value) {
      if (value !== null) {
        this.onItemSelected(value);
      }
    },
  },
};

</script>

<style lang="scss" scoped>

  .inline-selector{
    user-select: none;
    width: 100%;
    display: grid;
    grid-template-columns: 30px auto 30px;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 15px;

    &__list{
      overflow-x: scroll;
      white-space: nowrap;
      scroll-behavior: smooth;
      scrollbar-width: none;
      &__item{
        display: inline-block;
        &--default{
          display: inline-block;
          padding: 5px 14px;
          border-bottom: .2em solid $--color-light-grey-blue;
        }
        &--active{
          font-weight: $--font-weight-500;
          border-bottom: .2em solid $--color-secondary;
        }
      }
      &__item:hover{
        cursor: pointer;
      }
    }
  }
  .arrow:hover{
    cursor: pointer;
  }

  .selector-arrow {
    height: 30px;
    width: 30px;

    &__right {
      padding: 7px 0 7px 14px;
    }
    &__left {
      padding: 7px 14px 7px 0;
    }
  }

  ::-webkit-scrollbar {
    width: 10px;
    display: none;
  }

  .no-selectable {
    color: grey;
    cursor: not-allowed;
  }
  .no-grid {
    display: unset !important;
    width: unset  !important;
  }

  .no-display {
    display: none;
  }

</style>
